exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Switch\n   ========================================================================== */\n.switch {\n  display: inline-flex;\n  align-items: center;\n  color: #444;\n  cursor: pointer;\n  font-family: Roboto;\n  font-weight: 400;\n  padding: 1px; }\n\n.switch__input {\n  display: none; }\n\n.switch__slider {\n  display: block;\n  position: relative;\n  background-color: #c2c2c2;\n  cursor: pointer; }\n  .switch__slider:focus {\n    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 5px 0 rgba(0, 0, 0, 0.16); }\n  .switch__slider::after {\n    content: \"\";\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    bottom: 2px;\n    width: calc(50% - 1px);\n    background-color: #fff;\n    border-radius: 50%;\n    transition: 0.4s; }\n\n.switch--disabled {\n  opacity: 0.5;\n  pointer-events: none; }\n\n/* States\n   ========================================================================== */\n.switch__input:checked + .switch__slider {\n  background-color: #25b8d2; }\n\n.switch__input:checked + .switch__slider::after {\n  transform: translateX(calc(100% - 2px)); }\n\n/* Sizes\n   ========================================================================== */\n.switch--small .switch__slider {\n  height: 30px;\n  width: 54px;\n  border-radius: 15px; }\n\n.switch--small .switch__label {\n  margin-left: 6px;\n  font-size: 12px;\n  line-height: 16px; }\n\n.switch--medium .switch__slider {\n  height: 40px;\n  width: 74px;\n  border-radius: 20px; }\n\n.switch--medium .switch__label {\n  margin-left: 8px;\n  font-size: 14px;\n  line-height: 22px; }\n\n.switch--large .switch__slider {\n  height: 50px;\n  width: 94px;\n  border-radius: 25px; }\n\n.switch--large .switch__label {\n  margin-left: 10px;\n  font-size: 16px;\n  line-height: 28px; }\n\n@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\n  .switch__input:checked + .switch__slider::after {\n    left: auto;\n    right: 2px; } }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};